import React from 'react';
import '../App.css';
import { Link, useHistory } from 'react-router-dom';
import * as Colors from './colors'
import Api from './api/api'

const Privacy = () => {
    const history = useHistory()

    return (
        <div className='main'>

            <div className='login'>

                {/* <img
                    src={logo}
                    style={{ width: 200, objectFit: 'contain', alignSelf: 'center', marginBottom: 20 }} /> */}

                <div className='home-label' style={{ marginTop: 0, marginLeft: 0, alignSelf: 'center' }}>
                    Privacy Policy
                </div>

                <div className="form" style={{ marginTop: 20 }}>

                    

                </div>

            </div>
        </div>
    );
}

export default Privacy; 